/** 未包含store和wechat sdk引入 */
import Vue from './vue';
import router from './router';
import store from './store';
import logger from './logger';
import '../scss/alpaca/alpaca.scss';
import '../scss/route-transition.scss';
import '../scss/flex.scss';
import '../scss/fit.scss';

// 实际上要引入的是authorize、登录页
import '../request';

export default {
  logger
};

const visitTimestamp = new Date().getTime();
const supportPerformance = window.performance && window.performance.now;

new Vue({
  router,
  store,

  data() {
    return {
      transitionName: 'null',
      ts: ''
    };
  },

  created() {
    this.ts = this.getTs();
    window.gtHistoryPageLen = 1;
  },

  watch: {
    $route() {
      let ts = this.getTs();

      if (this.ts === undefined) {
        // this.transitionName = 'slide-init';
        this.transitionName = 'slide-push';
        window.gtHistoryPageLen = 2;
      } else if (ts < this.ts) {
        this.transitionName = 'slide-pop';
        window.gtHistoryPageLen--;
      } else if (ts === this.ts) {
        this.transitionName = 'slide-replace';
      } else {
        this.transitionName = 'slide-push';
        window.gtHistoryPageLen++;
      }
      this.ts = ts;
    }
  },

  methods: {
    getTs() {
      const state = window.history.state;
      if (!state || !state.key) {
        this.transitionName = 'null';
        return;
      }

      let ts = supportPerformance ? state.ts : parseFloat(state.key, 10);
      if (!ts) {
        // 因为vue-router设置state时优先使用performance.now，其次是Date.now，
        // 如果是performance的话在刷新或跳转再返回后没法比较，所以这里往state里添加一个时间戳。
        // 也是不更改vue-router源码的简单方法。
        ts = visitTimestamp + parseFloat(state.key, 10);
        window.history.replaceState({
          key: state.key,
          ts: ts
        }, '', window.location.href);
      }
      return ts;
    }
  },

  render(h) {
    return h('div', {
      attrs: {
        id: 'app'
      }
    }, [
      h(
        'keep-alive',
        {attrs: {include: 'huoliIOUSecKill'}},
        [h('router-view')]
      )
    ]);
  }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/app/start-base.js